export const validateLetterLow = str => str && str.search(/[a-z]/) === -1
export const validateLetterUpper = str => str && str.search(/[A-Z]/) === -1
export const validateLetterEspecial = str => str && str.search(/[~`_!#$@\^*=\-;,/{}|:\?]/) === -1 // eslint-disable-line
export const newDefaultPassword = value => {
  if (!value) {
    return value
  }
  return value.replace(/[^0-9a-zA-Z~`_!#$@\^*=\-;,/{}|:\?]+/g, '') // eslint-disable-line
}
